var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddBorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1133 9.16748H10.338V6.49561C10.338 6.41826 10.2723 6.35498 10.1919 6.35498H9.31551C9.23517 6.35498 9.16944 6.41826 9.16944 6.49561V9.16748H6.39412C6.31378 9.16748 6.24805 9.23076 6.24805 9.30811V10.1519C6.24805 10.2292 6.31378 10.2925 6.39412 10.2925H9.16944V12.9644C9.16944 13.0417 9.23517 13.105 9.31551 13.105H10.1919C10.2723 13.105 10.338 13.0417 10.338 12.9644V10.2925H13.1133C13.1937 10.2925 13.2594 10.2292 13.2594 10.1519V9.30811C13.2594 9.23076 13.1937 9.16748 13.1133 9.16748Z",
    fill: "#505050"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75412 1.85498C5.23691 1.85498 1.57422 5.38115 1.57422 9.72998C1.57422 14.0788 5.23691 17.605 9.75412 17.605C14.2713 17.605 17.934 14.0788 17.934 9.72998C17.934 5.38115 14.2713 1.85498 9.75412 1.85498ZM9.75412 16.269C6.00378 16.269 2.96188 13.3405 2.96188 9.72998C2.96188 6.11943 6.00378 3.19092 9.75412 3.19092C13.5045 3.19092 16.5463 6.11943 16.5463 9.72998C16.5463 13.3405 13.5045 16.269 9.75412 16.269Z",
    fill: "#505050"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBorder);
export default __webpack_public_path__ + "static/media/add-border.cc66006abc451f9081bd482258c6616b.svg";
export { ForwardRef as ReactComponent };